export default __webpack_public_path__ + "static/media/16-shine.cd05bc16.png";